import template from './lease-type-v2.jade';
import leaseType from '../../../enums/lease-type-v2';
import validation from './../../../services/validation';

export default angular
    .module('cian.addForm.leaseTypeV2', [])
    .directive('cianAfPriceAndDealTermsLeaseTypeV2', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';

            this.isMobile = deviceService.isMobile;

            this.leaseTypes = leaseType;

            this.validation = validation(this.form, 'bargainTerms.leaseType', {
                required: 'Укажите тип аренды',
            });
        },
        controllerAs: 'leaseType',
        template,
    }))
    .name;
